import type { FaireProductEntity } from "../../entity_types/product";

export const p_ha523qksy5: FaireProductEntity = {
  token: "p_ha523qksy5",
  type: "product",
  name: "*EXCLUSIVE* Playing Mahjong with Mah Girls 15 oz Soy Candle",
  brandToken: "b_1b0f6a45",
  brandName: "Sweet Water Decor",
  imageUrl:
    "https://cdn.faire.com/fastly/b392a5880e922570e00f835112735784f2a4605b95b66cca5518991d815b3662.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5566730e29166a429a490f467214fa778d34c559f95c98f9c73215e924b35e95.png",
    "https://cdn.faire.com/fastly/6e0bab704fd5c424b8143e8bf57b5a3bac312ef7e1aa906b81970b218f421587.png",
    "https://cdn.faire.com/fastly/9b68b63de207ade968fb84b75b927420c3cba54bcb2e4acf20a800e7a1b67b8f.png",
    "https://cdn.faire.com/fastly/ebb3a0670732bd37062dbdee784bc32669f46731da0d5e6878c1a5eb4b5d92bb.png",
    "https://cdn.faire.com/fastly/a866a27de815342f059fcda56608aae17955e9d66b95ca31ac3dbdb359c4d472.jpeg",
    "https://cdn.faire.com/fastly/9e38947280d67b81e9e7d02c029c8e01bc3f223d127152e2bbd6a878442f6e31.png",
    "https://cdn.faire.com/fastly/36fcea8709ae425f3d57aa61e96bd1de202c6c5b0b4134e9da52df6a12840e03.png",
  ],
  priceDollars: 22,
  description:
    '*FAIRE EXCLUSIVE - NOT ON AMAZON*\n\nOur Playing Mahjong with Mah Girls 15 oz candle was made for game nights and Mahjong gifting. Featuring our best-selling Salt and Sea fragrance, it sets the perfect mood for strategy, laughs, and friendly competition. Its warm glow and stylish pink jar make it a fun, decorative companion for your Mahjong table.\n\nSCENT NOTES:\n• Top: Sea Salt, Citrus\n• Middle: Musk\n• Base: Amber\n\nCANDLE INFO:\n• Size: Volume 15oz | 334g Net Weight | 3.25 x 3.63 x 4" \n• Burn Time: 70+ Hours \n• Wick: 100% Cotton (Lead and Zinc Free) \n• Wax: Proprietary Soy Based Wax Blend | Vegan, Non-GMO, Kosher | Made in USA \n• Premium Fragrance Oil\n• Gluten Free, Phthalate Free, Non-Toxic\n• Wood Lid \n• Made in Pittsburgh, PA \n• Style No. CL188-PK \n\nCATEGORIES:\ncandles wholesale, Mahjong, Mahjong gifts, Mahjong table',
  tags: [],
  msrpDollars: 44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:30.108Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
